import type { Resolvers } from '../../../../generated';
import { allSyncSessions, syncSessionsMap } from '../sync-session';

export const resolvers: Resolvers = {
  Mutation: {
    removeSyncSession: (_, vars) => {
      allSyncSessions.set((draft) =>
        draft.filter((f) => f && f.id !== vars.syncSessionId)
      );
      syncSessionsMap.update(vars.syncSessionId, null);
      return true;
    },
  },
};
